module.exports = __webpack_public_path__ + "static/media/radio-button-unselected.d628afb1.svg";